/**
 * Filkhedma API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface CustomerRegisterRequestV2 { 
    firstName?: string;
    lastName?: string;
    mobile?: string;
    email?: string;
    password?: string;
    gender?: CustomerRegisterRequestV2.GenderEnum;
    facebookAccessToken?: string;
}
export namespace CustomerRegisterRequestV2 {
    export type GenderEnum = 'male' | 'female';
    export const GenderEnum = {
        Male: 'male' as GenderEnum,
        Female: 'female' as GenderEnum
    };
}
